import { useState } from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { SpecialtyStrip } from "@/components/SpecialtyStrip";
import { ClientMarquee } from "@/components/ClientMarquee";
import { Services } from "@/components/Services";
import { HighTicket } from "@/components/HighTicket";
import { Industries } from "@/components/Industries";
import { FloatingStack } from "@/components/FloatingStack";
import { Manifesto } from "@/components/Manifesto";
import { Testimonials } from "@/components/Testimonials";
import { EcosystemLinks } from "@/components/EcosystemLinks";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppFab } from "@/components/WhatsAppFab";
import { BookingDialog } from "@/components/BookingDialog";
import { ShowreelModal } from "@/components/ShowreelModal";

export default function Home() {
  const [booking, setBooking] = useState(false);
  const [showreel, setShowreel] = useState(false);

  return (
    <div className="relative">
      <div className="noise" />
      <Header onBook={() => setBooking(true)} />
      <main>
        <Hero onBook={() => setBooking(true)} onShowreel={() => setShowreel(true)} />
        <SpecialtyStrip />
        <ClientMarquee />
        <Services />
        <HighTicket />
        <Industries />
        <FloatingStack />
        <Manifesto />
        <Testimonials />
        <EcosystemLinks />
        <Contact onBook={() => setBooking(true)} />
      </main>
      <Footer onBook={() => setBooking(true)} />
      <WhatsAppFab />
      <BookingDialog open={booking} onClose={() => setBooking(false)} />
      <ShowreelModal open={showreel} onClose={() => setShowreel(false)} />
    </div>
  );
}
